


















































































import { defineComponent } from '@nuxtjs/composition-api'
import IconFaSolidBars from '~icons/fa-solid/info-circle'

export default defineComponent({
  components: {
    IconFaSolidBars,
  },
})
